import { gql } from '@apollo/client';

export const VERIFY_EARLY_CODE = gql`
  query VerifyEarlyCode($code: String!, $experienceId: ID!) {
    verifyEarlyBirdCode(filter: { code: $code, experienceId: $experienceId }) {
      valid
    }
  }
`;
